export default __webpack_public_path__ + "static/media/ic_ok.bd5081cf.svg";